import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import Router from 'next/router';
import {
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';

import Link from 'next/link';
import { toggleLoginModal as _toggleLoginModal } from '../shared/actions/login-modal.action';
import { login as _login } from 'flaivy-react/actions/auth.actions';

import { SHOP_REDIRECT_AFTER_LOGIN_KEY } from '../config/api';

import { loadMyFavoriteArticles as _loadMyFavoriteArticles } from '../shared/actions/my-favorite-articles.action';
import { loadPersistedMultiCart as _loadPersistedMultiCart } from 'flaivy-react/actions/persisted-multi-cart.actions';
import StyledButton from 'flaivy-react/components/StyledButton';

function LoginModal({
  loginModalOpen,
  toggleModal,
  login,
  loadMyFavoriteArticles,
  loadPersistedMultiCart,
  shopConfig,
}) {
  console.log('🍄 ~ shopConfig:', shopConfig);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const redirectAfterLogin = Cookies.get(SHOP_REDIRECT_AFTER_LOGIN_KEY);

  async function onSubmit(event) {
    event.preventDefault();
    try {
      const auth = await login(email, password);
      if (auth && auth.isAuthenticated) {
        await loadMyFavoriteArticles();
        await loadPersistedMultiCart();
        if (redirectAfterLogin) {
          Cookies.remove(SHOP_REDIRECT_AFTER_LOGIN_KEY);
          Router.push(redirectAfterLogin);
        } else {
          Router.reload();
        }
      }
    } catch (err) {
      setErrorMessage('Felaktig e-post eller lösenord. Försök igen.');
    }
  }

  const toggle = () => {
    Cookies.remove(SHOP_REDIRECT_AFTER_LOGIN_KEY);
    toggleModal();
  };

  function toRegister() {
    toggleModal();
    Router.push('/register');
  }
  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        setErrorMessage('');
      }, 3500);
    }
  }, [errorMessage]);

  return (
    <Modal isOpen={loginModalOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Logga in</ModalHeader>

      <ModalBody className="py-0 p-lg-5">
        {redirectAfterLogin && (
          <Alert color="info">
            Sidan kräver att du är inloggad. Du kommer slussas vidare efter att
            du loggat in.
          </Alert>
        )}
        {errorMessage && (
          <Alert color="danger">
            <strong>Inloggningsfel</strong> {errorMessage}
          </Alert>
        )}
        <Form onSubmit={onSubmit}>
          <FormGroup className="mt-4">
            <Label for="emailaddress">E-post</Label>
            <Input
              type="email"
              name="email"
              id="emailaddress"
              value={email}
              onChange={x => setEmail(x.target.value)}
            />
          </FormGroup>
          <FormGroup>
            <Label for="password">Lösenord</Label>

            <Link
              className="text-muted float-end"
              href="/forgot-password"
              onClick={() => toggleModal()}
            >
              Glömt lösenord?
            </Link>
            <Input
              type="password"
              name="password"
              id="password"
              value={password}
              onChange={x => setPassword(x.target.value)}
            />
          </FormGroup>
          <div className="form-group mb-0 text-center">
            <StyledButton
              id="loginbutton"
              color="primary"
              className="fancy"
              type="submit"
              block
            >
              <i className="mdi mdi-login" /> Logga in
            </StyledButton>
            {!shopConfig.navbarConfig?.hideBecomeCustomerButton && (
              <>
                <div className="mt-1">eller</div>
                <div className="mt-1">
                  <Button color="link" onClick={toRegister}>
                    Skapa nytt konto
                  </Button>
                </div>
              </>
            )}
            <div className="mt-1">
              <p className="text-xs text-muted mt-2">
                Genom att logga in godkänner jag användandet av{' '}
                <Link target="_blank" href="/general-terms">
                  cookies
                </Link>
              </p>
            </div>
          </div>
        </Form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = ({ loginModal, shopConfig }) => ({
  loginModalOpen: loginModal.loginModalOpen,
  shopConfig,
});

const mapDispatchToProps = {
  toggleModal: _toggleLoginModal,
  login: _login,
  loadMyFavoriteArticles: _loadMyFavoriteArticles,
  loadPersistedMultiCart: _loadPersistedMultiCart,
};

LoginModal.propTypes = {
  loginModalOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  shopConfig: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
